module.exports = __webpack_public_path__ + "static/img/app_logo_single.4069f75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/app_logo_single.png
// module id = 234
// module chunks = 32